import React, { useContext, useState } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import Text from 'components/Text/Text';
import Button from 'components/Button/Button';
import FullInfoField from 'components/FullInfoField/FullInfoField';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import classNames from 'classnames';
import style from './Bpa.module.scss';

export const Bpa: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);
	const [isOpenFields, setIsOpenFields] = useState(false);
	const expandIconClasses = classNames(style.expandIcon, { [style.rotated]: isOpenFields });
	const expandFieldsClasses = classNames({ [style.collapsed]: !isOpenFields });

	return (
		<>
			<FullInfoField
				label="setLabel"
				value={restaurantForFullInfo?.bpaSet && restaurantForFullInfo.bpaSet.name}
			/>
			{!!restaurantForFullInfo?.bpaSet && (
				<div className={style.bpaFields}>
					<Button
						className={style.expandButton}
						theme="secondaryPurple"
						onClick={() => setIsOpenFields((state) => !state)}
						icon={
							<svg className={expandIconClasses}>
								<use xlinkHref={`${breadcrumbs}#rightAngleArrow`} />
							</svg>
						}>
						<Text
							translationNameSpace="form"
							translationKey={isOpenFields ? 'hideAddedFieldsButton' : 'expandAddedFieldsButton'}
							asFragment={true}
						/>
					</Button>
					<div className={expandFieldsClasses}>
						<div className={style.row}>
							<FullInfoField
								label="recipientAccountNumberLabel"
								value={restaurantForFullInfo.bpaSet.recipientAccountNumber}
							/>
							<FullInfoField
								label="recipientNameLabel"
								value={restaurantForFullInfo.bpaSet.recipientName}
							/>
						</div>
						<div className={style.row}>
							<FullInfoField
								label="recipientBankLabel"
								value={restaurantForFullInfo.bpaSet.recipientBank}
							/>
							<FullInfoField
								label="recipientBankCityLabel"
								value={restaurantForFullInfo.bpaSet.recipientBankCity}
							/>
						</div>
						<div className={style.row}>
							<FullInfoField
								label="recipientInnLabel"
								value={restaurantForFullInfo.bpaSet.recipientInn}
							/>
							<FullInfoField
								label="recipientBicLabel"
								value={restaurantForFullInfo.bpaSet.recipientBic}
							/>
						</div>
						<div className={style.row}>
							<FullInfoField
								label="recipientCorrespondentAccountLabel"
								value={restaurantForFullInfo.bpaSet.recipientCorrespondentAccount}
							/>
							<FullInfoField
								label="paymentDetailsLabel"
								value={restaurantForFullInfo.bpaSet.paymentDetails}
							/>
						</div>
						<div className={style.row}>
							<FullInfoField
								label="cardContractNumberLabel"
								value={restaurantForFullInfo.bpaSet.cardContractNumber}
							/>
							<FullInfoField
								label="sbpContractNumberLabel"
								value={restaurantForFullInfo.bpaSet.sbpContractNumber}
							/>
						</div>
					</div>
				</div>
			)}
		</>
	);
};
